import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CommonHttpService } from '../http';
import { AppStore } from '../../store';
import dayjs from 'dayjs';
import { VCBCurrencyExchangeResponse } from '../../models/api/common';

@Injectable({
  providedIn: 'root',
})
export class CommonService {
  private _commonHttp = inject(CommonHttpService);
  private _appStore = inject(AppStore);
  private _http = inject(HttpClient);

  checkIp() {
    this._commonHttp.checkIp().subscribe((res) => {
      if (res.ip) {
        console.log(res.ip);
      }
    });
  }

  getExchangeRate() {
    const today = dayjs();
    const apiUrl = `https://www.vietcombank.com.vn/api/exchangerates?date=${today.format('YYYY-MM-DD')}`;
    return this._http
      .get<VCBCurrencyExchangeResponse>(apiUrl)
      .subscribe((res) => {
        this._appStore.updateCurrencyExchange(res);
      });
  }
}
